export const PASSWORD_MIN_LENGTH = 12;

export function signupValidationMessage(email: string, password: string): string | null {
  if (!email.includes("@")) return "Enter a valid email address.";
  if (password.length < PASSWORD_MIN_LENGTH) return "Password must be at least 12 characters.";
  return null;
}
